export enum Environment {
  LOCAL = 'LOCAL',
  PCE = 'PCE',
  DEV = 'DEV',
  QA = 'QA',
  STG = 'STG',
  PROD = 'PROD',
  PROD_EU = 'PROD_EU',
  GOV_STG= 'GOV_STG',
  GOV_PROD= 'GOV_PROD',
}

export const getCurrentEnvironment = (): Environment => {
  const mc = window.mc
  const variables = mc && mc.variables
  const environment = variables && variables.environment

  return environment || Environment.LOCAL
}

export const isPCE = () => {
  return getCurrentEnvironment() === Environment.PCE
}

export const isGovCloud = () => {
  const currentEnv = getCurrentEnvironment()
  return currentEnv === Environment.GOV_STG || currentEnv === Environment.GOV_PROD
}

export const isPCEOrGov = () => {
  return isGovCloud() || isPCE()
}

export const hideIfPCEOrGovCloud = (hideForPCE?: boolean, hideForGovCloud?: boolean) => {
  if (isPCE()) return hideForPCE
  if (isGovCloud()) return hideForGovCloud
  return false
}
